export default "__VITE_ASSET__D8D1Ie$t__"